import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addclienttrade',
    templateUrl: './addclienttrade.component.html',
    styleUrls: ['./addclienttrade.component.css']
})
export class AddClientTrade {
    element: any = {};
    populateEmail: string = '';
    myForm: any = FormControl;
    otherFormEnabled: boolean = false;
    userEmailEnabled: boolean = false;
    liqpairs: any = [];
    Pair: string = "";
    Client: string = "";
    clients: any = [];
    users: any = [];
    feeValue:any;
    public pairListSearchCopy: any = []
    public clientListSearchCopy: any = []
    public selectedDate = new Date();
    constructor(
        public dialogRef: MatDialogRef<AddClientTrade>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public clientService: ClientOrderService
    ) {
        this.getInternalPairList();
        this.getClients();
        this.element = data;
        this.element['OrderType'] = "MANUAL";
        this.element['OrderSource'] = "MANUAL";
        this.element['WalletType'] = "USER";

        this.myForm = this.fb.group({
            UserEmail: ['', [Validators.required]],
            Pair: ['', [Validators.required]],
            TradeDate: ['', [Validators.required]],
            Side: ['', [Validators.required]],
            TradeQuantity: ['', [Validators.required, Validators.min(0.00001)]],
            TradePrice: ['', [Validators.required, Validators.min(0.00001)]],
            TradeAmount: ['', [Validators.required]],
            OrderSource: [''],
            OrderType: [''],
            Client: [''],
            OfflineClientName: [''],
            OfflineClientEmail: [''],
            OrderId: [''],
            TradeId: [''],
            ClientOrderId: [''],
            Fee: ['', [Validators.min(0)]],
            FeeCurrency: [''],
            CommentText: [''],
            WalletType:['USER', [Validators.required]],
            TDS: [0, [Validators.min(0)]]
        });

        // ADDED DYNAMIC VALIDATION
        this.myForm.get('Fee').valueChanges
            .subscribe(value => {
                this.feeValue = value;
                if (value > 0) {
                    this.myForm.controls["FeeCurrency"].setValidators([Validators.required]);
                    this.myForm.controls["FeeCurrency"].updateValueAndValidity();
                }
                else {
                    this.myForm.controls["FeeCurrency"].clearValidators();
                    this.myForm.controls["FeeCurrency"].updateValueAndValidity();
                }
            });
    }
    getInternalPairList() {
        this.userService.getInternalPair().subscribe(response => {
            response = response.map(function (item) {
                return { pair: `${item.BaseCCY}${item.QuoteCCY}` };
            })
            this.liqpairs = response.map(item => item.pair)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.pairListSearchCopy = this.liqpairs;
        })
    }   
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        const selectedValue = event.option.value;
        if (selectedValue === 'Others') {
            this.getOthersData();
        } else {
            // Handle other user selections
            // ...
        }
    }

    getClients() {
        this.userService.getClients().subscribe(clients => {
            this.users = clients;
            clients = clients.map(function (item) {
                return { clientName: item.name };
            })
            this.clients = clients.map(list => list.clientName)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.clientListSearchCopy = this.clients;
        })
    }
    pairsearch_manualtrade(): void {
        let term = this.Pair;
        this.liqpairs = this.pairListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
        this.element['Pair'] = this.liqpairs[0];
    }
    clientSearch(event) {
        if (event !== 'Others') {
            let term = this.element['Client'];
            if (event === term) {
                this.myForm.controls['UserEmail'].clearValidators();
                this.myForm.controls['UserEmail'].updateValueAndValidity();
                this.userEmailEnabled = true;
            } else {
                this.userEmailEnabled = false;
                this.myForm.controls['UserEmail'].setValidators(Validators.required);
                this.myForm.controls['UserEmail'].updateValueAndValidity();

            }
            this.populatedEmail()
            this.clients = this.clientListSearchCopy.filter(function (tag) {
                if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                    return tag;
                }
            });
            this.otherFormEnabled = false;
        } else {
            this.otherFormEnabled = true;
            this.userEmailEnabled = false;
            // Clear the UserEmail field
            this.element['UserEmail'] = '';
        }
    }
    populatedEmail = () => {
        // Find the selected user object based on the selected user name
        const selectedUser = this.clientListSearchCopy.find(user => user === this.element['Client']);
        const result = this.users.find(user => user.name === selectedUser);
        if (result && result.email) this.populateEmail = result.email ? result.email : '';
        this.element['UserEmail'] = this.populateEmail;
    }
    getOthersData() {
        this.otherFormEnabled = true;
    }
    calculateTradeAmount(): void {
        if (this.data.TradeQuantity && this.data.TradePrice) {
            this.data.TradeAmount = this.data.TradeQuantity * this.data.TradePrice;
        } else {
            this.data.TradeAmount = null; // Clear the trade amount if either trade quantity or trade price is not provided
        }
    }
    onTradeQuantityChange(): void {
        this.calculateTradeAmount();
    }
    async saveClientTrade() {
        this.userService.csrf().subscribe(data => {
            const { notif } = defaults
            this.element['_csrf'] = data['_csrf'];
            this.element['TradeTS'] = moment(this.selectedDate).valueOf();
            this.element['TradeDate'] = moment(this.selectedDate).format('YYYY-MM-DD HH:mm:ss');
            if (!this.element['Pair']) {
                return this.notifSer.error('Error', 'Please fill the Pair', notif);
            }
            if (!this.element['TradeDate']) {
                return this.notifSer.error('Error', 'Please fill the Trade Date', notif);
            }
            if (!this.element['Side']) {
                return this.notifSer.error('Error', 'Please fill the Side', notif);
            }
            if (!this.element['TradeQuantity']) {
                return this.notifSer.error('Error', 'Please fill the Trade Quantity', notif);
            }
            if (!this.element['TradePrice']) {
                return this.notifSer.error('Error', 'Please fill the Trade Price', notif);
            }
            if (!this.element['TradeAmount']) {
                return this.notifSer.error('Error', 'Please fill the Trade Amount', notif);
            }
            if (this.feeValue > 0 && !this.element['FeeCurrency']) {
                return this.notifSer.error('Error', 'Please fill the Fee Currency', notif);
            }
            if (this.feeValue < 0) return this.notifSer.error('Error', 'Fee Value cannot be negative', notif);
            if(this.otherFormEnabled && !this.element['OfflineClientName']) {
                return this.notifSer.error('Error', 'Please fill the OfflineClientName', notif);
            }
            if(this.otherFormEnabled && !this.element['OfflineClientEmail']) {
                return this.notifSer.error('Error', 'Please fill the OfflineClientEmail', notif);
            }
            this.userService.saveClientTrade(this.element).subscribe(data => {
                if (data.status) {
                    this.notifSer.success('Success', data.message, notif)
                    // Emit the form data when closing the dialog

                    this.dialogRef.close({ success: true, data: data });

                } else this.notifSer.error('Error', data.message, notif);
            }, err => this.notifSer.error('Error', err.error.message, notif))
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/addclienttrade/addclienttrade.component.ts